export default __webpack_public_path__ + "5af29e3af06d0c58a14eb1812187c58a.jpg";